// extracted by mini-css-extract-plugin
export default {"scrollToTop":"ScrollToTop_scrollToTop__BTGNz","bounce":"ScrollToTop_bounce__CzanG"};